
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import constant from '../../constant';
import ItemForm from '../ui/itemform';
import { Loader2, ArrowLeft } from 'lucide-react';

const EditItems = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [gstRate, setGstRate] = useState('');
  const [price, setPrice] = useState('');
  const [isTaxInclusive, setIsTaxInclusive] = useState(false);
  const [itemType, setItemType] = useState('');
  const [hsnCode, setHsnCode] = useState('');
  const [unit, setUnit] = useState('');
  const [isActive, setIsActive] = useState(true);

  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchItem = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('No authentication token found');
          return;
        }

        const response = await fetch(`${constant.REACT_APP_API_URL}/item/${id}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        const result = await response.json();

        if (response.ok) {
          const data = result.data[0];
          setName(data.name);
          setGstRate(data.gstRate);
          setPrice(data.price);
          setIsTaxInclusive(data.isTaxInclusive);
          setItemType(data.itemType);
          setUnit(data.unit);
          setHsnCode(data.hsnCode);
          setIsActive(data.isActive);
        } else {
          setError(result.message || 'Failed to fetch item data');
        }
      } catch (error) {
        setError('Error fetching item data');
      } finally {
        setLoading(false);
      }
    };

    fetchItem();
  }, [id]);

  // Corrected handleSubmit function - remove event argument and event.preventDefault()
  const handleSubmit = async (itemData) => {
    setIsEditing(true);

    const updatedItem = {
      ...itemData, // Use itemData directly as it contains form values
      isActive,
    };

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found');
        return;
      }

      const response = await fetch(`${constant.REACT_APP_API_URL}/item/${id}`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedItem),
      });

      const result = await response.json();

      if (response.ok) {
        navigate('/items');
      } else {
        setError(result.message || 'Failed to update item');
      }
    } catch (error) {
      setError('Error updating item');
    } finally {
      setIsEditing(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6 pt-20 md:pt-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex items-center space-x-4">
            <button onClick={handleBack} className="text-gray-500 hover:text-gray-700 transition-colors">
              <ArrowLeft className="h-6 w-6" />
            </button>
            <h2 className="text-2xl font-bold text-gray-800">Edit Item</h2>
          </div>
        </div>

        {loading && (
          <div className="bg-blue-50 text-blue-700 p-4 rounded-lg mb-6">
            Processing...
          </div>
        )}
        {error && (
          <div className="bg-red-50 text-red-700 p-4 rounded-lg mb-6">
            {error}
          </div>
        )}

        <ItemForm
          name={name}
          setName={setName}
          gstRate={gstRate}
          setGstRate={setGstRate}
          price={price}
          setPrice={setPrice}
          isTaxInclusive={isTaxInclusive}
          setIsTaxInclusive={setIsTaxInclusive}
          itemType={itemType}
          setItemType={setItemType}
          hsnCode={hsnCode}
          setHsnCode={setHsnCode}
          unit={unit}
          setUnit={setUnit}
          isActive={isActive}
          setIsActive={setIsActive}
          loading={loading}
          isEditing={isEditing}
          isEditMode={true}
          onSubmit={handleSubmit} // Pass the corrected handleSubmit
          onCancel={handleBack} // Changed from onBack to onCancel to match ItemForm props
          error={error}
        />


      </div>
    </div>

  );
};

export default EditItems;